
export const getRandomItems = (arr, n) => {
    const result = [];

    // Get n unique items from the array
    while (result.length < n) {
        const randomIndex = Math.floor(Math.random() * arr.length);
        const item = arr[randomIndex];

        // Check if the item is already in the result array
        if (!result.includes(item)) {
            result.push(item);
        }
    }

    return result;
};

export const selectItemsWithChance = (arr) => {
    let result = [];

    arr.forEach((item) => {
        if (Math.random() < 0.1) { // 10% chance
            result.push(item);
        }
    });

    return result;
};
